const CustomPagination = ({ currentPage, setCurrentPage, pageCount, hasNextPage, hasPreviousPage, value }) => {
    const pageNumbers = [];

    for (let i = 0; i < pageCount; i++) {
        pageNumbers.push(i);
    }

    const getPaginationButtons = () => {
        let start = currentPage - 2;
        let end = currentPage + 2;
        if (start < 1) {
            end -= start - 1;
            start = 1;
        }
        if (end > pageNumbers.length) {
            end = pageNumbers.length;
        }
        return pageNumbers.slice(start - 1, end);
    };

    return (
        <ul>
            <li>
                <button
                    className="btn btn-outline-primary"
                    disabled={!currentPage > 0}
                    onClick={() => {
                        setCurrentPage(currentPage - 1);
                    }}
                >
                    <i className="fa-solid fa-arrow-left"></i>
                </button>
            </li>
            {getPaginationButtons().map((i) => (
                <li key={i}>
                    <button
                        className="btn btn-outline-primary"
                        key={i}
                        disabled={i === currentPage}
                        onClick={() => {
                            setCurrentPage(i);
                        }}
                    >
                        {i + 1}
                    </button>
                </li>
            ))}
            <li>
                <button
                    className="btn btn-outline-primary"
                    disabled={pageCount === currentPage + 1}
                    onClick={() => {
                        setCurrentPage(currentPage + 1);
                    }}
                >
                    <i className="fa-solid fa-arrow-right"></i>
                </button>
            </li>
        </ul>
    );
};
export default CustomPagination;
